const appendFormError = (errorMessageWrapper, isBlock, errorText) => {
    let errorDOMStr = (isBlock === true) ? '<div ' : '<span ';
    errorDOMStr += 'class="error" style="display: none;">' + errorText;
    errorDOMStr += (isBlock === true) ? '</div>' : '</span>';

    const errorMessage = $(errorDOMStr);
    if (errorMessageWrapper.find(".error").length) {
        errorMessageWrapper.find("span.error").remove();
    }
    errorMessageWrapper.append(errorMessage);

    errorMessage.stop(true, true).slideDown(500);
}

const validateFormAgreement = (form) => {
    const agreeFormBock = form.find("div.agree");

    if (!form.find("input[name='agree']").length || form.find("input[name='agree']").prop("checked") !== false) {
        return;
    }
    if (agreeFormBock.find(".error").length) {
        agreeFormBock.find(".error").remove();
    }
    appendFormError(agreeFormBock, true, 'You must agree with Terms and Conditions');

    form.find("input[name='agree']").on("change", function () {
        if ($(this).prop("checked") === true && agreeFormBock.find(".error").length) {
            agreeFormBock.find(".error").remove();
        }
    });
}

export { appendFormError, validateFormAgreement }
